module.exports = __webpack_public_path__ + "img/logo.7ce77ad1.png";